import { useCallback } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellString } from '../../table/cells/CellString';

export const ModelCellArrayBase = ({
  getValue,
  ...props
}: TableInheritedProps) => {
  const syntheticGetValue = useCallback(
    () => getValue!()?.join(', '),
    [getValue]
  );

  return <CellString getValue={syntheticGetValue} {...props} />;
};

export const ModelCellArray = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellArray', ModelCellArrayBase, props);
